import { Navigate, Outlet, useLocation } from "react-router-dom";
import { LoadingState } from "@/components/feedback/states";
import { useAuth } from "./auth-context";

export function ProtectedRoute() { const auth = useAuth(); const location = useLocation(); if (auth.loading) return <LoadingState label="Verifying secure session…" />; if (!auth.session || !auth.admin) return <Navigate to="/login" state={{ from: location.pathname + location.search }} replace />; return <Outlet />; }
